export const CALCULATION_BULLET_POINTS_TITLE = 'Beregning er alt. Inklusiv';

export const CALCULATION_BULLET_POINTS_ENTRIES = [
  'Varmepumpe og/eller solceller',
  'Installation og montering',
  'Demontering af eksisterende varmekilde',
];

export const CALCULATION_BULLET_POINTS_ENTRIES_NORLYS = [
  'Varmepumpe',
  'Installation og montering',
  'Demontering af eksisterende varmekilde',
];
